import { useEffect, useRef } from 'react';
import { ASSETS } from '@/constants/assets';

export default function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      const scrollY = window.scrollY;
      const opacity = Math.max(0, 1 - scrollY / 600);
      heroRef.current.style.opacity = String(opacity);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      id="forca-industrial"
      ref={heroRef}
      className="relative min-h-screen flex items-center overflow-hidden bg-gp-graphite"
    >
      <div className="absolute inset-0">
        <img
          src={ASSETS.heroHome}
          alt="Oficina da Pilar Manutenção Industrial com equipamentos e componentes hidráulicos em organização"
          className="w-full h-full object-cover object-center opacity-40"
          style={{
            imageRendering: '-webkit-optimize-contrast',
            maxWidth: '100%',
          }}
          loading="eager"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gp-graphite via-gp-graphite/80 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 pt-24 pb-20">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
            <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">
              Soluções Hidráulicas desde 2007
            </span>
          </div>

          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold text-white uppercase leading-[0.95] mb-8">
            Força<br />
            <span className="text-gp-yellow">Industrial</span>
          </h1>

          <p className="text-gray-300 text-lg md:text-xl max-w-xl leading-relaxed mb-10">
            Serviços hidráulicos de campo, manutenção industrial e reparo em oficina.
            A divisão <span className="text-df-orange font-semibold">DURAFLOW</span> oferece equipamentos hidráulicos de alta qualidade para toda a indústria brasileira.
          </p>

          <a
            href="#solucoes"
            className="inline-flex bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-8 py-4 rounded-sm font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap mb-16"
          >
            Conheça Nossos Serviços
          </a>

          <div className="flex items-center gap-8">
            <div>
              <span className="font-display text-3xl md:text-4xl font-bold text-white">18+</span>
              <p className="text-gray-500 text-xs uppercase tracking-wider mt-1">Anos de experiência</p>
            </div>
            <div className="w-[1px] h-12 bg-gray-700"></div>
            <div>
              <span className="font-display text-3xl md:text-4xl font-bold text-white">500+</span>
              <p className="text-gray-500 text-xs uppercase tracking-wider mt-1">Clientes atendidos</p>
            </div>
            <div className="w-[1px] h-12 bg-gray-700"></div>
            <div>
              <span className="font-display text-3xl md:text-4xl font-bold text-white">15K+</span>
              <p className="text-gray-500 text-xs uppercase tracking-wider mt-1">Serviços realizados</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#about" className="text-gray-500 hover:text-gp-yellow transition-colors duration-300">
          <i className="ri-arrow-down-line text-2xl w-8 h-8 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}